import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { LuPlus, LuUsers } from 'react-icons/lu';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

/**
 * What `/groups` shows a member who is in no group yet.
 *
 * The groups grid used to stand here and answer two questions at once — "which
 * group?" and "you have none". The first is the switcher's job now, so all that
 * is left of the grid is its empty state, which is the only thing it said that
 * a group's own hub could not.
 */
export function NoGroupsScreen() {
    const navigate = useNavigate();

    return (
        <EmptyState
            icon={<LuUsers size={48} />}
            title={
                <FormattedMessage
                    id="14b05d40-4d97-46b5-9799-e13c429c34eb"
                    defaultMessage="No groups yet"
                />
            }
            description={
                <FormattedMessage
                    id="cf7bab38-aff3-47d5-b3b8-ca54a2425f42"
                    defaultMessage="Create a group to start searching for homes together."
                />
            }
        >
            <Button onClick={() => navigate('/onboarding?flow=group')}>
                <LuPlus />
                <FormattedMessage
                    id="d494fceb-3118-494f-b77f-f7366620d04d"
                    defaultMessage="Create your first group"
                />
            </Button>
        </EmptyState>
    );
}
